export const formatLocation = (path: string | string[]) => {
    if (!Array.isArray(path)) {
        return path;
    }

    const formattedLocation = path.filter((value) => {
        return !['property', 'houses', 'flats', 'retirement'].includes(value);
    });

    return formattedLocation.join('/');
};
